// JsFromRoutes CacheKey f97bdf9d5e754691edf4547570f3fccc
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  section: /* #__PURE__ */ definePathHelper('get', '/pages/page_section/:page_id/:section_id'),
  sitePageSectionSite: /* #__PURE__ */ definePathHelper('get', '/sites/:site_id/pages/page_section/:page_id/:section_id'),
  simpleroComPageSection: /* #__PURE__ */ definePathHelper('get', '/pages/page_section/:page_id/:section_id'),
}
